import { JsonPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { OfficeService } from '../../services/office.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-test-page',
  standalone: true,
  imports: [JsonPipe, RouterLink, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './test-page.component.html',
  styleUrl: './test-page.component.scss',
})
export class TestPageComponent {
  officeService = inject(OfficeService);
  testResult = {};
  loadOfficeDate(officeId: string): void {
    console.log('input ', officeId);
    this.testResult = {};
    this.officeService.getOfficeTest(
      officeId,
      res => {
        console.log('res ', res);
        this.testResult = res as object;
      },
      error => {
        console.log('res ', error);
        this.testResult = error as object;
      }
    );
  }
}
